import { defineComponent as _defineComponent } from 'vue'
import { getDict } from '@/api/common'
import { Select } from 'ant-design-vue'
import { onMounted, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectDict',
  props: {
    dictName: null
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as {
  dictName: string
};



const options = ref()

function onChange(val: string) {
  emit('input', val)
}

const loading = ref(false)
onMounted(() => {
  loading.value = true
  getDict(props.dictName)
    .then((response) => {
      if (Array.isArray(response.data)) {
        options.value = response.data.map((i) => ({
          label: i.dictLabel,
          value: i.dictValue,
        }))
      }
    })
    .finally(() => {
      loading.value = false
    })
})

return { __sfc: true,props, options, emit, onChange, loading, Select }
}

})